import { handleize } from '../../utils/handleize';
export const getIconName = (name) => {
    return `icon__layout_${handleize(name)}`;
};
